import styled from "styled-components";
import { space } from "@scriba/ui-lib";

export const BottomButton = styled("div")`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  margin-top: ${space("xxl")}px;
`;
